module.exports = __webpack_public_path__ + "img/家宴·开席.6b709ce4.png";